<template>
  <span> 
       <b-badge variant="danger" v-if="orders.length > 0" @update-orders="getOrders"> {{orders.length}}</b-badge>
  </span>
</template>

<script>
import axios from "axios";
export default {
  name: 'App',
  data () {
    return { 
      orders: [],
      drawer: true,
    }
  }, 
  computed:{
   
  },
  created(){ 
     this.getOrders(); 
    
  },
  methods:{ 
    getOrders() { 
        console.log("SI ENTRA");
        axios
        .get("orders")
        .then(res => { 
            if (res.data) {  
                this.orders = res.data.filter(order => order.status == false); 

            } 
        })
        .catch(error => {
            this.isLoading = false; 
        });
    },  
   
  }
}
</script>

<style>

</style>